export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;

  return new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

export const formatTime = (timeString: string): string => {
  const date = new Date(`2000-01-01T${timeString}`);
  if (Number.isNaN(date.getTime())) return timeString;

  return new Intl.DateTimeFormat('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);
};

export const formatDateTime = (isoString: string): string => {
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return isoString;

  return new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);
};

export const getGreeting = (labels?: { greetingMorning: string; greetingAfternoon: string; greetingEvening: string }): string => {
  const hour = new Date().getHours();
  if (hour < 12) return labels?.greetingMorning ?? 'Good Morning';
  if (hour < 17) return labels?.greetingAfternoon ?? 'Good Afternoon';
  return labels?.greetingEvening ?? 'Good Evening';
};

export const getInitials = (name: string): string => {
  if (!name) return '';
  return name
    .split(' ')
    .map((part) => part.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');
};
